import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a47a3cc")

_pushScopeId("data-v-3a47a3cc")
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#responsive-layout" }),
  /*#__PURE__*/_createTextVNode(" Responsive Layout ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Taking example by Bootstrap's responsive design, five breakpoints are preset: xs, sm, md, lg and xl. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "grid-content bg-purple-light" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_row, { gutter: 10 }, {
        default: _withId(() => [
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 6,
            md: 4,
            lg: 3,
            xl: 1
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 6,
            md: 8,
            lg: 9,
            xl: 11
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 4,
            sm: 6,
            md: 8,
            lg: 9,
            xl: 11
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 8,
            sm: 6,
            md: 4,
            lg: 3,
            xl: 1
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.code6), 1)
        ]),
        _: 1
      })
    ])
  ]))
})